module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00582.34d031bf.jpg";